import { FC } from "react";

import { PillBannerButton } from "components/footer/PillBannerButton";
import { type PresentationBannerColorType } from "components/footer/PresentationBanner";
import { t } from "i18n/i18n";

export type StopPresentingButtonProps = {
  color: PresentationBannerColorType;
  onStopPresenting: () => void;
  showShortText?: boolean;
  eventName?: string;
};

export const StopPresentingButton: FC<StopPresentingButtonProps> = ({
  color,
  onStopPresenting,
  showShortText,
  eventName,
}) => (
  <PillBannerButton eventName={eventName} kind={`banner-${color}`} onClick={onStopPresenting}>
    {showShortText ? t("main_header.stop_short") : t("main_header.stop_presenting")}
  </PillBannerButton>
);
